import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    Button,
    IconButton,
    Box,
    Select, MenuItem, FormControl
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { fetchUniversitiesNames } from "../../api/universityApi";
import FormSelectAutocomplete from "../UniversityCRMEntryForm/FormSelectAutocomplete";
import FormTextInput from "../UniversityCRMEntryForm/FormTextInput";
import { paymentStatusList } from "../common/CommonFilterTab";
import CurrenyAmtFieldInput from "../CurrenyAmtFieldInput";
import UploadFile from "./UploadFile";
import { validateSchema } from "../../utils/validation/validationSchema";
import ValidationErrorText from "../common/ValidationErrorText";
import { fetchCoursesByUniversityId } from "../../api/courseApi";
import { fetchSpecializationByUniversityId } from "../../api/specializationApi";
import { saveNewAdmission } from "../../api/admissionApi";
import { useNotification } from "../../hooks/useNotification";
import FormPhoneInputField from "../common/FormPhoneInputField";

const AdmissionModal = ({refetch, open, handleClose,formData={}, setFormData=()=>{} }) => {
    const [universityIdOptions, setUniversityIdOptions] = useState([])
    const [courseOptions, setCourseOptions] = useState([])
    const [specializationOptions, setSpecializationOptions] = useState([])
    const [fieldError, setFieldError] = useState(null)
    const [saving, setSaving] = useState(false)
    const { showSuccessNotification, showErrorNotification } = useNotification()



    const handleAdmissionSubmit = () => {
        saveNewAdmission(formData, setSaving)
            .then(() => {
                showSuccessNotification(formData?.admissionId ? "Admission updated successfully" : 'Admission saved successfully')
                handleClose()
                refetch && refetch()
            })
            .catch((err) => {
                showErrorNotification(err.message || 'Failed to save admission')
            })
    }

    const runValidation = async (type) => {
        const errors = await validateSchema(formData, "admission");
        setFieldError(errors);
        if (type == "submit" && Object.keys(errors?.errors).length === 0) {
            handleAdmissionSubmit()
        }
    };


    useEffect(() => {
        fetchUniversitiesNames(setUniversityIdOptions)
    }, [])

    // load university courses
    useEffect(() => {
        if (!formData?.universityId?.value) return
        fetchCoursesByUniversityId(
            formData?.universityId?.value,
            (courseOptions) => {
                setCourseOptions(courseOptions)
            }
        ).catch((err) => {
            console.log('err', err)
        })
       !formData?.admissionId && setFormData({ ...formData, courseNameId: "", specializationNameId: "", })
    }, [formData?.universityId])

    // load course specializations
    useEffect(() => {
        if (!formData?.universityId?.value || !formData?.courseNameId?.courseId) return
        fetchSpecializationByUniversityId(
            formData?.universityId?.value,
            formData?.courseNameId?.courseId,

            (options) => {
                setSpecializationOptions(options)
            }
        ).catch((err) => {
            console.log('err', err)
        })
         !formData?.admissionId &&  setFormData({ ...formData, specializationNameId: "", })
    }, [formData?.courseNameId])

    useEffect(() => {
        if (fieldError?.errors && Object.keys(fieldError.errors)?.length) {
            runValidation();
        }
    }, [formData]);

    const handleOnChange = (value, type) => {
        setFormData({ ...formData, [type]: value })
    }


    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            {/* Header */}
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #eee",
                }}
            >
                <Typography sx={{ color: "#15243E", fontWeight: 600, fontSize: "20px !important" }}>
                    New Admission
                </Typography>
                <IconButton onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            {/* Content */}
            <DialogContent dividers>
                <Box sx={{ display: "flex", gap: 1, mb: 1, }}>
                    {/* Mobile No */}
                    <Box sx={{ width: '100%' }}>
                        <FormPhoneInputField label={"Mobile No *"} value={formData?.phone} placeholder="Enter mobile number" onChange={(value) => handleOnChange(value, "phone")} fieldError={fieldError?.errors['phone']} />
                    </Box>

                    {/* Email */}
                    <Box sx={{ width: '100%' }}>
                        <FormTextInput label={"Email Id *"} value={formData?.email} placeholder="Enter email address" onChange={(value) => handleOnChange(value, "email")} fieldError={fieldError?.errors['email']} />
                    </Box>
                </Box>
                <Box sx={{ display: "flex", gap: 1, mb: 1, }}>
                    {/* Full Name */}
                    <Box sx={{ width: '100%' }}>
                        <FormTextInput label={"Full Name *"} value={formData?.fullName} placeholder="Enter student full name" onChange={(value) => handleOnChange(value, "fullName")} fieldError={fieldError?.errors['fullName']} />
                    </Box>

                    {/* University (Searchable) */}
                    <Box sx={{ width: '100%' }}>
                        <FormSelectAutocomplete
                            label={"University *"}
                            value={formData?.universityId}
                            options={universityIdOptions}
                            placeholder="Select University"
                            fieldError={fieldError?.errors['universityId']}
                            onChange={(value) => handleOnChange(value, "universityId")}
                        />
                    </Box>
                </Box>
                <Box sx={{ display: "flex", gap: 1, mb: 1, }}>
                    {/* Course (Searchable) */}
                    <Box sx={{ width: '100%' }}>
                        <FormSelectAutocomplete
                            label={"Course *"}
                            value={formData?.courseNameId}
                            key={formData?.universityId}
                            options={courseOptions}
                            placeholder="Select Course"
                            fieldError={fieldError?.errors['courseNameId']}
                            onChange={(value) => handleOnChange(value, "courseNameId")}
                        />
                    </Box>

                    {/* Specialization (Searchable) */}
                    <Box sx={{ width: '100%' }}>
                        <FormSelectAutocomplete
                            key={formData?.courseNameId}
                            label={"Specialization *"}
                            value={formData?.specializationNameId}
                            options={specializationOptions}
                            placeholder="Select Specialization"
                            fieldError={fieldError?.errors['specializationNameId']}
                            onChange={(value) => handleOnChange(value, "specializationNameId")}
                        />
                    </Box>
                </Box>
                <Box sx={{ width: '100%', display: 'flex', gap: 1, }}>
                    <CurrenyAmtFieldInput label={"Course fees (₹)"} value={formData?.courseFee} onChange={(value) => handleOnChange(value, "courseFee")} fieldType="courseFee" fieldErrors={fieldError?.errors} />
                    <CurrenyAmtFieldInput label={" Paid Amt. (₹)"} value={formData?.paidAmt} onChange={(value) => handleOnChange(value, "paidAmt")} fieldType="paidAmt" fieldErrors={fieldError?.errors} />

                    <Box width="100%">
                        <Typography sx={{ fontSize: "13px", fontWeight: 500, color: "#363853", mb: "7px" }}>
                            Payment Type
                        </Typography>
                        <Box width="100%">
                            <FormControl sx={{ minWidth: 80, width: '100%' }}>
                                <Select
                                    value={formData?.paymentStatus}
                                    onChange={(e) => handleOnChange(e?.target?.value, "paymentStatus")}
                                    IconComponent={KeyboardArrowDownIcon}
                                    displayEmpty
                                    sx={{
                                        width: '100%',
                                        "& .MuiSelect-select": {
                                            padding: "0px 12px",
                                            height: "40px !important",
                                            display: "flex",
                                            alignItems: "center",
                                        },
                                    }}
                                >
                                    {paymentStatusList?.map(item => <MenuItem key={item?.value} value={item?.value}>
                                        <em>{item.label}</em>
                                    </MenuItem>)}
                                </Select>
                            </FormControl>
                        </Box>
                        <ValidationErrorText error={fieldError?.errors['paymentStatus']} />

                    </Box>
                </Box>



                {/* File Upload */}
                <UploadFile label={"Upload Receipt"} acceptFile={".pdf,.png"} value={formData?.receipt} acceptFileLabel={"Choose PDF/PNG File"} onChange={(value) => handleOnChange(value, "receipt")} fieldError={fieldError?.errors['receipt']} />
                {/* <Box
                    sx={{
                        width: "100%",
                        border: "2px dashed #1075FF",
                        borderRadius: "10px",
                        p: 2,
                        background: "#EDF4FF",
                        position: "relative",
                        mt: 2,
                        cursor: "pointer", // show pointer on hover
                    }}
                    onClick={handleBoxClick} // trigger input click
                >
                    <input
                        type="file"
                        accept=".pdf,.png"
                        hidden
                        ref={fileInputRef}
                        onChange={handleFileChange}
                    />
                    <Box sx={{ display: "flex", gap: "12px", alignItems: "center", justifyContent: "center" }}>
                        <BackupOutlinedIcon sx={{ color: "#1075FF", height: "40px", width: "40px" }} />
                        <Box sx={{ textAlign: "center" }}>
                            <Button variant="outlined" component="label" sx={{ border: "none" }}>
                                Upload Receipt
                            </Button>
                            <Typography sx={{ fontSize: "14px" }}>Choose PDF/PNG File</Typography>

                            {fileName && (
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Typography sx={{ fontSize: "13px", fontWeight: 500, color: "#555" }}>
                                        Selected: {fileName} ({fileSize} KB)
                                    </Typography>
                                    <IconButton size="small" onClick={handleRemoveFile}>
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Box> */}

                {/* Buttons */}
                <Box sx={{ display: "flex", gap: "12px", width: "100%", mt: 2 }}>
                    <Button
                        onClick={handleClose}
                        sx={{ width: "48%", border: "1px solid #ddd", color: "#363853", borderRadius: "8px" }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => runValidation("submit")}
                        sx={{
                            width: "48%",
                            background: "#1075FF",
                            color: "#fff",
                            borderRadius: "8px",
                            "&:hover": { background: "#0a5edc" },
                        }}
                    >
                        Submit
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default AdmissionModal;
